<header class="header">
    <div class="text-container">
        <h1 class="main-header">PricePoint Portal By DIGI</h1>
        <h2 class="sub-header">Quote Smarter. Sell Faster.</h2>
    </div>
</header>